import { render, staticRenderFns } from "./SetupTelkomNewDevice.vue?vue&type=template&id=29d5b81c"
import script from "./SetupTelkomNewDevice.vue?vue&type=script&lang=js"
export * from "./SetupTelkomNewDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports